export function InitMobileMenu() {
    const mobileButton = document.querySelector('.site-header--mobile-button')

    // Get the header element with the class "site-header"
    const headerElement = document.querySelector('header.site-header');

    // Add a click event listener to the toggle button
    mobileButton.addEventListener('click', function() {
        // Get the current value of the data attribute
        const currentValue = headerElement.getAttribute('data-mobile-menu-open');

        // Toggle the value between true and false
        const newValue = (currentValue === 'true') ? 'false' : 'true';

        // Update the data attribute value
        headerElement.setAttribute('data-mobile-menu-open', newValue);
    });


    const mobileSubMenuToggles = document.querySelectorAll('.sub-menu-toggle')

    mobileSubMenuToggles.forEach(button => {
        button.addEventListener('click', (event) => toggleMobileSubMenu(button))
    })

    function toggleMobileSubMenu(button) {
        var subMenu = button.parentNode.nextElementSibling; // Get the next sibling element (the submenu)
        const isActive = subMenu.classList.toggle('active');
        button.setAttribute('aria-expanded', isActive);
    }
}